import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Button, Dropdown } from "react-bootstrap";
import { CardFilterBtn } from "./categoryCardStyle";
import { CategoryCardProps } from "../../../utils/types";
import { MESSAGE } from "../../../utils/message";

const CategoryCard = ({ setCategorySlug, categorySlug, setCategoryName, categoryData }: CategoryCardProps) => {
  const first15Categories = categoryData?.slice(0, 15);
  const remainingCategories = categoryData?.length > 15 ? categoryData?.slice(15) : [];
  const foundCategory: any = remainingCategories?.find((category: any) => category?.slug === categorySlug);



  return (
    <CardFilterBtn as={Col} sm="12" className="category-btn-group">
      <Button className={categorySlug === ' ' ? "active" : ''} onClick={() => setCategorySlug('all')}>All</Button>
      {first15Categories?.map((category: any, index: number) => (
        <Button key={index + 1} onClick={() => { setCategorySlug(category?.slug); setCategoryName(category?.name) }} className={categorySlug === category?.slug ? `active` : ""}>{category.name}</Button>))}
      {remainingCategories?.length > 0 && (
        <Dropdown className={foundCategory?.slug ? `active` : ""}>
          <Dropdown.Toggle>
            {MESSAGE.more}
          </Dropdown.Toggle>
          <Dropdown.Menu className="custom-dropdown">
            <div className="custom-scrollbar">
              {remainingCategories?.map((category: any, index: number) => (
                <Dropdown.Item
                  key={index + 1}
                  style={{
                    backgroundColor: categorySlug === category?.slug ? "#f0f0f0" : "",
                    padding: "8px 0",
                    marginBottom: "5px"
                  }}
                  onClick={() => setCategorySlug(category?.slug)}
                >
                  {category?.name}
                </Dropdown.Item>
              ))}
            </div>
          </Dropdown.Menu>
        </Dropdown>)}
    </CardFilterBtn>
  );
}
export default CategoryCard;